module.exports = window.jQuery;


//////////////////
// WEBPACK FOOTER
// external "window.jQuery"
// module id = 127c8cf59f228bb01a21
// module chunks = 1